module.exports = __webpack_public_path__ + "static/elli-8a555faa11b020a41e3c7bec3df0449c.png";